import * as actions from 'app/actions/trailer';
import http from 'app/services/http';

export const trailerReducer = (
    state = {
        items: [],
        checkedItems: [],
        selectedItem: null,
        sortSelectedItem: { name: config.trailerColumns[0].name, order: config.trailerColumns[0].order },
        searchValue: '',
    },
    action
) => {
    switch (action.type) {
        case 'TRAILER_SET_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                items: items,
            };
        }
        case 'TRAILER_SET_SELECTED_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                selectedItem: data,
            };
        }

        case 'TRAILER_SET_SEARCH_VALUE': {
            const { value } = action.payload;

            return {
                ...state,
                searchValue: value,
            };
        }
        case 'TRAILER_SET_SORT_SELECTED_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                sortSelectedItem: {
                    name: data.name,
                    order: state.sortSelectedItem.name !== data.name ? data.order : state.sortSelectedItem.order === 'ASC' ? 'DESC' : 'ASC',
                },
            };
        }
        case 'TRAILER_ADD_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                items: [...state.items, data],
            };
        }

        case 'TRAILER_UPDATE_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                selectedItem: data,
                items: state.items.map((value) => {
                    if (value.id !== state.selectedItem.id) {
                        return value;
                    }

                    return data;
                }),
            };
        }
        case 'TRAILER_DELETE_ITEM': {
            const { id } = action.payload;

            return {
                ...state,
                items: state.items.filter((item) => item.id !== id),
                selectedItem: null,
            };
        }
        default:
            return state;
    }
};

export function trailerLoad() {
    return async function trailerLoadThunk(dispatch) {
        const { data } = await http.get('/trailer');
        return dispatch(actions.setItems(data));
    };
}

export async function trailerFormLoad() {
    return http
        .get('/trailer')
        .then((response) => response.data)
        .then((response) => {
            return response;
        })
        .catch();
}

export function trailerCreate(params) {
    return async function trailerCreateThunk(dispatch) {
        const { data } = await http.post('/trailer', params);
        return dispatch(actions.addItem(data));
    };
}

export function trailerUpdate(id, params) {
    return async function trailerUpdateThunk(dispatch) {
        const { data } = await http.put(`/trailer/${id}`, params);
        return dispatch(actions.updateItem(data));
    };
}

export function trailerDelete(id) {
    return async function trailerDeleteThunk(dispatch) {
        await http.delete(`/trailer/${id}`);
        return dispatch(actions.deleteItem(id));
    };
}

export default trailerReducer;
